import { render, staticRenderFns } from "./BaseFormSelect.vue?vue&type=template&id=451b742e&scoped=true&"
import script from "./BaseFormSelect.vue?vue&type=script&lang=js&"
export * from "./BaseFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormSelect.vue?vue&type=style&index=0&id=451b742e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b742e",
  null
  
)

export default component.exports